import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function(params) {
      return qs.stringify(params, { encode: false });
    }
  };

  return axios.get(`${url}/faturaextratos?include=fatura,contrato,seguroincendio`, options).then(response => {
    return {
      list: jsona.deserialize(response.data),
      meta: response.data.meta
    };
  });
}

function get(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };
  
  return axios
    .get(`${url}/faturaextratos/${id}?include=fatura,contrato,seguroincendio`, options)
    .then(response => {
      let faturaextrato = jsona.deserialize(response.data);
      delete faturaextrato.links;
      return faturaextrato;
    });
}

function add(faturaextrato) {
  const payload = jsona.serialize({
    stuff: faturaextrato,
    includeNames: ["categories"]
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  
  //.post(`${url}/faturaextratos?include=fatura,contrato,seguroincendio`, payload, options)
  return axios
    .post(`${url}/faturaextratos?include=fatura,contrato,seguroincendio`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function update(faturaextrato) {
  const payload = jsona.serialize({
    stuff: faturaextrato,
    includeNames: []
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  
  return axios
    .patch(`${url}/faturaextratos/${faturaextrato.id}?include=fatura,contrato,seguroincendio`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios.delete(`${url}/faturaextratos/${id}`, options);
}
function downloadPDF(tipo, arquivo) {
  return axios.get(`${url}/downloads/${tipo}/${arquivo}.pdf`, { responseType: 'blob' }).then((response) => {
    return response.data;
  });
}
/*
function upload(faturaextrato, image) {
  const bodyFormData = new FormData();
  bodyFormData.append("attachment", image);

  return axios
    .post(`${url}/uploads/faturaextratos/${faturaextrato.id}/image`, bodyFormData)
    .then(response => {
      return response.data.url;
    });
}
export default {
  list,
  get,
  add,
  update,
  destroy,
  upload
};
*/
export default {
  list,
  get,
  add,
  update,
  destroy,
  downloadPDF
};